import React, {useState, useEffect } from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {dictWork, dictUnit,  dictMonth} from "utils/validationFunction";
import {ButtonTextMUI as Button} from "utils/componentsStyle";
import ModalDialog from "views/Widgets/Common/ModalDialog";
import TableComponent from "views/Widgets/Common/TableComponent";
import TextField from "@material-ui/core/TextField";
import {red, green} from "@material-ui/core/colors";
import NumberFormat from "react-number-format";
import api from "utils/API";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator="."
      decimalSeparator=","
      isNumericString
      allowNegative={false}
    />
  );
}

export default function ModalEndMultipleWork({
    open,
    handleClose,
    dataArray,
    setdata,
}) {

    const [dictValue, setdictValue] = useState({});


    const incompleteStateArray = ["Incompleto", "PorRealizar"];
    const filedDataList = dataArray.filter(
        (row) => incompleteStateArray.includes(row.estado)
    ).filter(
        (row) => moment(row.fecha_hora).isSame(moment(), "day")
    )

    const header = [
        {label: "Medición"},
        {label: "Fecha"},
        {label: "Valor"},
    ]

    const data =  filedDataList.filter(
        (row) => dictWork[row.comentarios]
    ).map((row, index) => {
        const value = dictValue[row.id] || 0;
        const label = `${row.descripcion} ${dictUnit[row.comentarios] || ""}`
        const _textField_ = <TextField
            id="outlined-basic"
            label={label}
            variant="outlined"
            value={value}
            InputProps={{
            inputComponent: NumberFormatCustom
            }}
            onChange={e => {
            if (/^[0-9\b]+$/.test(e.target.value)) {
                setdictValue({...dictValue, [row.id]: parseInt(e.target.value)});
            }
            }}
        />

        return [
            {value: label},
            {value: moment(row.fecha_hora).format("YYYY-MM-DD hh:mm") },
            {value: value, _value_: _textField_},
        ]
    });

    const dataBalance =  filedDataList.filter(
        (row) => row.comentarios === "Egresos" || row.comentarios === "Ingresos"
    ).map((row, index) => {
        const value = dictValue[row.id] || 0;
        const label = `${row.comentarios}/${row.descripcion} ml`

        const _textField_ = <TextField
            id="outlined-basic"
            label={label}
            variant="outlined"
            value={value}
            InputProps={{
            inputComponent: NumberFormatCustom
            }}
            onChange={e => {
            if (/^[0-9\b]+$/.test(e.target.value)) {
                setdictValue({...dictValue, [row.id]: parseInt(e.target.value)});
            }
            }}
        />

        return [
            {value: label},
            {value: moment(row.fecha_hora).format("YYYY-MM-DD hh:mm") },
            {value: value, _value_: _textField_},
        ]
    });

    const handleSave = () => {
        const auxFileDataList =  filedDataList.filter((row) => dictValue[row.id])
        const listWorkBalance = auxFileDataList.filter(
            (row) => row.comentarios === "Egresos" || row.comentarios === "Ingresos"
        ).map((row) => {
            return {
                id: row.id,
                valor: dictValue[row.id],
            }
        })

        const listWorkSV = auxFileDataList.filter(
            (row) => dictWork[row.comentarios]
        ).map((row) => {
            return {
                id: row.id,
                valor: dictValue[row.id],
            }
        })

        const body = {
            "signos_vitales": listWorkSV,
            "balance": listWorkBalance,
            "ficha": auxFileDataList[0].id_ficha
        }

        api.post(`api/paciente/tareaspaciente/diarias/`, body).then((response) => {

            const tempArray = dataArray.map((row) => {
                const tempRow = {...row};
                if (dictValue[row.id]){
                    tempRow.estado = "Completado";
                }
                return {...tempRow }
            })
            setdata(tempArray)
            handleClose();
        });

    }

    const _content_ = <div>
        <TableComponent
            headers={header}
            data={[...data, ...dataBalance]}
        />
    </div>

    const validation = Object.keys(dictValue).length > 0

    const _actions_ = <>
        {validation ?
        <Button
            mr={2}
            variant="contained"
            style={{backgroundColor: green[500], marginRight: "3px", marginLeft: "10px"}}
            className="text-white"
            onClick={handleSave}
        >
            Guardar
        </Button> :
        <Button
            disabled
            mr={2}
            variant="contained"
            style={{ marginRight: "3px", marginLeft: "10px"}}
        >
            Guardar
        </Button>
        }

        <Button
            mr={2}
            variant="contained"
            style={{backgroundColor: red[500], marginRight: "10px", marginLeft: "3px"}}
            className="text-white"
            onClick={handleClose}
        >
            Cerrar
        </Button>
    </>


    return (
        <ModalDialog
            open={open}
            onClose={handleClose}
            title={`Completar tareas - ${moment().format("D")} de ${dictMonth[parseInt(moment().format("MM"))]}`}
            _content_={_content_}
            _actions_ = {_actions_}
            maxWidth="md"
        />
  );
}